export default class {
    constructor (ModalService, TokenService, COURSE_TRAINING_MATERIAL_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM) {
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
    }

    hasAccessToScormStudyMaterials (currentId, scormCourses) {
        // as we have lazy loading of scorm courses, do not show notification if no courses are presented
        if (!currentId || !scormCourses.length) {
            return true;
        }

        return !!scormCourses.find((course) => course.id === currentId);
    }

    launchScormPreview (scormCourseId) {
        return this.ModalService.open({
            template: `
                <modals-courses-version-training-scorm-preview
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    preview="vm.preview"
                />
            `,
            resolve: {
                preview: (ScormCloudResource) => {
                    return ScormCloudResource.preview({ courseId: scormCourseId }).$promise;
                }
            },
            controller ($uibModalInstance, preview) {
                this.$uibModalInstance = $uibModalInstance;
                this.preview = preview;
            },
            size: 'xlarge'
        });
    }

    showScormMaterials (trainingForm) {
        return this.TokenService.isScormCloudEnabled()
            && trainingForm.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.SCORM
            && trainingForm.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/scorm/index.js